// Updated walkInForm.jsx with shared pricing calculations
import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import moment from 'moment';
import VehicleSelectForm from './../../vehicleSelection';
import ServiceForm from './../../newServiceForm';
import NotesForm from './../../notesForm';
import DatesForm from './../../dateWalkForm';
import CustomerForm from './../../newCustomerForm';
import { HTTPService } from "./../../../services/httpService";
import { convertToUTC } from '../../../util/convert_timezone';
import dateService from '../../../services/dateService';
import LocationService from '../../../services/locationService';
// UPDATED: Import shared pricing module instead of old serviceUtils
import { 
  SharedRequestPricing, 
  SharedPricingUtils 
} from './../services/sharedPricingCalculations';
import ReactGA from 'react-ga4';
import _ from 'lodash';
import LocationSelector from '../../common/LocationSelector';
import { isMultiLocation } from '../../../util/locationUtils';

const API = new HTTPService();

class WalkinForm extends Component {

  constructor(props) {

    super(props);

    // Get referral data immediately for initial state
  const referralData = this.props.location?.state?.referralData;
  const duplicateData = this.props.location?.state?.duplicateData;

    this.state = {
      redirect: false,
      currentStep: 1,
      // REMOVED: hardcoded platformFee - will use shared config
      customer: duplicateData?.customer || referralData?.customer || "",
      customerName: duplicateData?.customerName || referralData?.customerName || "",
      customerEmail: duplicateData?.customerEmail || referralData?.customerEmail || "",
      customerType: duplicateData?.customerType || (referralData ? "retail" : ""),
      vehicle: duplicateData?.vehicle || referralData?.vehicle || '',
      duplicateRequestId: duplicateData?.requestId || null,
      services: [],
      total : 0,
      discount : 0,  // UPDATED: Now properly tracks discounts
      fee : 0,
      loading:false,
      notes:"",
      taxRate : 0,
      taxPercent : 0,
      availableDate: new moment().startOf('day'),
      dueDate: new moment().startOf('day'),
      newVehicleId: {},
      newRequestId: {},
      user: this.props.user,
      excludeDays : [],
      dealerships : [],
      authenticated : 0,
      serviceHint: referralData?.requestedService || null,
      referralId: referralData?.referralId || null,
      referralLocationId: referralData?.locationId || null,
      sendEstimate: false, // Send estimate PDF to customer
      formLocationId: this.props.selectedLocationId || (this.props.locations?.length === 1 ? this.props.locations[0].location_id : null),
    };
    
    this.handleChange = this.handleChange.bind(this);
    this.handleServices = this.handleServices.bind(this);
    this.handleCustomer = this.handleCustomer.bind(this);
    this.handleVIN = this.handleVIN.bind(this);
    this.handleNotes = this.handleNotes.bind(this);
    this.handleDueDate = this.handleDueDate.bind(this);
    this.handleAvailableDate = this.handleAvailableDate.bind(this);
    this._next = this._next.bind(this);
    this._prev = this._prev.bind(this);
this.handleStockNumberChange = this.handleStockNumberChange.bind(this);
this.handleDealNumberChange = this.handleDealNumberChange.bind(this);
  }

  async componentDidMount() {

    let installerRequest = "/installerLocations/"+this.props.typeId;        
    const  { data : installer }  =  await API.get(installerRequest);
   
    const firstOne = installer.shift();
    this.setState({ installer : firstOne });
//    //console.log("Installer : ",this.state.installer);
    if (firstOne && firstOne.stripe_tax_rate) {
      let taxRequest = "/taxes/"+firstOne.stripe_tax_rate;
      const  { data : taxRate }  =  await API.get(taxRequest);
      this.setState({ taxPercent : taxRate.percentage });
    } else {
      console.error(
        `[walkInForm] Missing stripe_tax_rate for installer ${this.props.typeId}`,
        `location_id=${firstOne && (firstOne.location_id || firstOne.Location_id)}.`,
        `Tax rate must be configured on installer_locations — defaulting to 0% is NOT correct.`
      );
    }
      //read the installer calendar to manage the bookings
  
      const locParam = this.props.selectedLocationId && this.props.selectedLocationId !== 'all'
        ? `?locationId=${this.props.selectedLocationId}` : '';
      let calendarRequest = `/dealerCalendars/${this.props.typeId}${locParam}`;

      const  { data : dealerCalendarDays }  = await API.get(calendarRequest);

      calendarRequest = `/installerCalendars/${this.props.typeId}${locParam}`;

      const  { data : installerCalendarDays }  = await API.get(calendarRequest);
    
      var calendarList = dealerCalendarDays.concat(installerCalendarDays);
    
      var calendarDays = _.orderBy(calendarList, ['workDate'],['asc']);
      this.setState({ calendarDays });
    
      // Create the array of the booked calendar services in the upcoming 60 days

      if (calendarDays.length > 0){
        const startDate = moment.utc().format("YYYY-MM-DD");

//           //console.log("CC - start Date", startDate);
        var totalDuration = 60;

        // caalendarInWindow
        var bookedArray = calendarDays.filter(day => moment.utc(day.workDate).diff(startDate) >= 0);

//         //console.log( "Upcoming calendar : ", bookedArray);
//         //console.log("CC - start Date", startDate);
//         //console.log("Installer :", this.state.installer);

        //capacityCalendar
        var bookedData = new Array(totalDuration);

        for (var m=0; m < totalDuration; m++) {
          bookedData[m] = {'x' : m, 'exDate' : moment.utc(startDate).add(m,"days").format("YYYY-MM-DD") ,'y' : 0};
      };

      // Need to build the array of booked capacity here for the next 60 days
      for (let k=0; k < bookedData.length; k++ ){
        // for every day in the calendar days, add up the daily_work and assign it to the right day
        let matchingWork = bookedArray.filter(work => moment.utc(work.workDate).format("YYYY-MM-DD") === bookedData[k].exDate);
        let dayTotal = matchingWork.reduce( function (result, value) {
          return result + value.capacity
        } , 0)
        bookedData[k].y = dayTotal;
      };

      let exclude = [];
//       //console.log ("Booked data length :", bookedData.length)
      for (let b=0; b< bookedData.length; b++){
        // this should be the capacity of the installer vs the size of job
        if (bookedData[b].y >= this.state.installer.capacity * 2){
//           //console.log ("Exclude :", new Date(moment(bookedData[b].exDate).format("MMMM D, YYYY")));
          exclude.push(new Date(moment(bookedData[b].exDate).format("MMMM D, YYYY")));
        }
    }
    
          this.setState( { excludeDays : exclude, bookedDays : bookedData});
    //      //console.log("Booked Array :", bookedData);
    //      //console.log("Excluded dates :", exclude)    
          };
    // read the dealerships to populate the dealer table      
          let dealerRequest = "/dealers";        
          const  { data : dealerships }  =  await API.get(dealerRequest);
          this.setState( {dealerships});

      // Fetch operating hours for the selected location (for scheduling timestamps)
      const locationId = this.state.formLocationId || this.props.selectedLocationId;
      if (locationId && locationId !== 'all') {
        try {
          const hoursData = await LocationService.getOperatingHours(locationId);
          this.setState({ operatingHours: hoursData.hours || hoursData });
        } catch (err) {
          console.log('Could not fetch operating hours, using defaults');
        }
      }

      //check if authenticated
      await this.readAuth(this.props.typeId);
      // Referral data is already set in constructor, just log for confirmation
      const referralData = this.props.location?.state?.referralData;
      if (referralData) {
        console.log("Referral data processed in componentDidMount:", {
          customer: this.state.customer,
          customerName: this.state.customerName,
          customerEmail: this.state.customerEmail,
          vehicle: this.state.vehicle,
          referralId: this.state.referralId
        });
      }

      // Duplicate/Rebook flow: customer is pre-filled, advance to vehicle step
      // VehicleSelectForm will auto-decode the VIN, then handleVIN will advance to step 3
      const duplicateData = this.props.location?.state?.duplicateData;
      if (duplicateData) {
        console.log("Duplicate/Rebook data processed:", {
          customer: this.state.customer,
          customerName: this.state.customerName,
          vehicle: this.state.vehicle,
          duplicateRequestId: this.state.duplicateRequestId
        });
        // Use functional setState to avoid overwriting if VIN decode already advanced past step 2
        // Also create a new vehicle reference to trigger VehicleSelectForm.componentDidUpdate
        this.setState(prevState => ({
          currentStep: Math.max(prevState.currentStep, 2),
          vehicle: { ...prevState.vehicle }
        }));
      }
  };

checkVehicleComplete = () => {
    const vehicle = this.state.vehicle;
    
    // Must have ALL required fields for service catalog accuracy
    const isComplete = vehicle && 
           vehicle.year && 
           vehicle.make && 
           vehicle.model && 
           vehicle.trim && 
           vehicle.body &&
           vehicle.id_car_trim; // This is critical for service catalog
        
    return isComplete;
};

handleSubmit = async (e, createAppointment = false) => {
  e.preventDefault();
  this.setState({ loading: true });

  try {
    console.log("Starting job creation with services:", this.state.services);
    console.log("Create appointment:", createAppointment);

    // Validate services before proceeding
    const validationResult = SharedPricingUtils.validatePricingData(this.state.services);
    if (!validationResult.isValid) {
      throw new Error(`Pricing validation failed: ${validationResult.errors.join(', ')}`);
    }

    // Determine job type and tax configuration
    const jobType = this.state.customerType === "whole" ? "dealer" : "retail";
    const taxRate = this.state.customerType === "whole" ? 0 : this.state.taxPercent;

    // Get complete pricing breakdown using shared module
    const pricingBreakdown = SharedRequestPricing.getCompletePricingBreakdown(this.state.services, {
      jobType: jobType,
      taxRate: taxRate
    });

    console.log("Pricing breakdown for installer job:", pricingBreakdown);

    // STEP 1: Complete ALL Jobvious database work first
    console.log("Starting job creation process...");

    // Add vehicle if needed
    if (!this.state.vehicle.id) {
      console.log("Adding vehicle...");
      await this.addVehicle();
    }

    // Add the main request with calculated pricing
    console.log("Adding request...");
    const newRequest = await this.addRequest(pricingBreakdown, createAppointment);

    // Always add "created" as the first state for consistency
    console.log("Adding request state... created");
    await this.addRequestState(newRequest, "created", null);

    // If booking appointment or wholesale, also add "scheduled" state
    if (this.state.customerType === "whole" || createAppointment) {
      console.log("Adding request state... scheduled");
      await this.addRequestState(newRequest, "scheduled", null);
    }

    // Add note (FIX: Added missing await)
    console.log("Adding note...");
    await this.addNote(newRequest);
    
    // Add services with calculated pricing
    console.log("Adding services...");
    await this.addServices(newRequest, pricingBreakdown);
    
    // Add request offered
    console.log("Adding request offered...");
    await this.addOffer(createAppointment, pricingBreakdown.totalDuration);
    
    // Add Jobvious calendar entries (created as "draft" by POST /schedule)
    console.log("Adding to Jobvious calendar...");
    await this.addCalendar();

    // If booking appointment or wholesale, flip calendar entries from "draft" to "booked"
    if (this.state.customerType === "whole" || createAppointment) {
      console.log("Flipping calendar entries to booked...");
      await this.bookCalendarEntries();
    }

    console.log("✅ Core job creation completed successfully");

    // STEP 2: Update referral status if this came from a referral
    if (this.state.referralId) {
      console.log("Updating referral status for referral ID:", this.state.referralId);
      try {
        await this.updateReferralStatus(this.state.referralId, newRequest);
        console.log("✅ Referral status updated to ESTIMATE_CREATED");
      } catch (referralError) {
        console.error("Failed to update referral status:", referralError);
        // Don't fail the entire flow
      }
    }

    // STEP 3: Attempt Google Calendar sync as silent bonus feature
    if ((this.state.customerType === "whole" || createAppointment) && this.state.authenticated) {
      console.log("Attempting Google Calendar sync...");
      try {
        await this.addAppointmentSilently(newRequest);
        console.log("✅ Google Calendar sync completed as bonus");
      } catch (calendarError) {
        console.log("Google Calendar sync skipped (optional feature):", calendarError.message);
        // Completely silent - no user notification for calendar failures
      }
    }

    // STEP 4: Send email notification if creating appointment for retail
    if (createAppointment && this.state.customerType !== "whole") {
      console.log("Sending booking confirmation email...");
      try {
        await this.sendEmail(newRequest);
        console.log("✅ Booking email sent");
      } catch (emailError) {
        console.log("Email notification skipped:", emailError.message);
        // Silent - don't fail the flow
      }
    }

    // STEP 4b: Send estimate to customer if checkbox checked
    if (this.state.sendEstimate) {
      console.log("Sending estimate to customer...");
      try {
        await API.post(`/requests/${newRequest}/send-quote`);
        // Add request state record for estimate sent
        await this.addRequestState(newRequest, "estimate_sent", null);
        console.log("✅ Estimate sent to customer");
      } catch (quoteError) {
        console.error("Failed to send estimate:", quoteError);
        // Don't fail the flow, but notify user
        alert("Estimate created but email failed to send. You can resend from the request detail page.");
      }
    }

    // STEP 5: Complete workflow based on job type
    this.setState({ loading: false });

    if (this.state.customerType !== "whole") {
      if (createAppointment) {
        alert("Job booked successfully! Appointment created and confirmation email sent.");
        ReactGA.event({category: 'Installer', action: 'Created and Booked Estimate', label: 'prod'});
        window.location = "/jobs?filter=scheduled";  // Redirect to scheduled jobs when appointment is booked
      } else {
        const message = this.state.sendEstimate
          ? "Estimate created and sent to customer!"
          : "Adding the estimate to your list";
        alert(message);
        ReactGA.event({category: 'Installer', action: 'Created Estimate', label: 'prod'});
        window.location = "/requestimates";  // Redirect to estimates when just creating estimate
      }
    } else {
      alert("Adding this dealer work to your calendar");
      window.location = "/jobs?filter=scheduled";  // Redirect to scheduled jobs for dealer work
      ReactGA.event({category: 'Installer', action: 'Created Job', label: 'prod'});
    }

  } catch (error) {
    console.error('❌ Error creating job:', error);
    this.setState({ loading: false });
    alert('Error creating job: ' + error.message);
  }
};

// ADD this new silent calendar sync method (same pattern as requestimates.jsx):
addAppointmentSilently = async (requestId) => {
  try {
    console.log("Silent calendar sync starting for request:", requestId);
    
    // Use the same server endpoints as the working requestimates.jsx code
    let readAppt = `/readAppt/${requestId}`;
    const { data: appt } = await API.get(readAppt);

    if (!appt || appt.length === 0) {
      throw new Error('No appointment data found for calendar sync');
    }

    let newAppt = {
      request: requestId,
      summary: `${appt[0].Year} ${appt[0].Make} ${appt[0].Model}`,
      description: `Customer: ${this.state.customerName || 'Dealer Job'}`,
      calendar: appt[0].calendar_id,
      startDate: appt[0].work_date,
      duration: appt[0].request_duration,
      installerId: this.props.typeId,
    };

    console.log("Sending to Google Calendar:", newAppt);
    
    let apptAdd = `/addAppt/`;
    const response = await API.put(apptAdd, newAppt);
    
    console.log("Google Calendar response:", response.data);
    return response.data;
    
  } catch (error) {
    // Silent failure - just log, don't throw
    console.log('Silent Google Calendar sync failed:', error.message);
    return null;
  }
};

// Add this method to WalkInForm
updateReferralStatus = async (referralId, requestId) => {
  // Handle case where requestId might be an object or just the ID
  const actualRequestId = typeof requestId === 'object'
    ? (requestId.request_id || requestId.requestId || requestId.id || requestId)
    : requestId;

  console.log("updateReferralStatus called with:", {
    referralId,
    requestIdParam: requestId,
    actualRequestId
  });

  const updateData = {
    referralId: referralId,
    status: 'ESTIMATE_CREATED',
    request_id: actualRequestId  // Link the referral to the created request
  };

  console.log("Sending referral update:", updateData);
  const response = await API.put('/referrals', updateData);
  console.log("Referral update response:", response.data);
  return response.data;
};

// Send booking confirmation email to customer
sendEmail = async (request) => {
  console.log("📧 FRONTEND: Initiating booking email send for request:", request);
  console.time(`📧 Frontend Email Send - ${request}`);

  try {
    const response = await API.get(`/sendemailb/${request}`);
    console.timeEnd(`📧 Frontend Email Send - ${request}`);

    console.log("📧 FRONTEND: Email API response:", response.data);

    if (response.data && response.data.success) {
      console.log("✅ FRONTEND: Booking email sent successfully for request:", request);
      return true;
    } else if (response.status === 200 && !response.data.success) {
      // Handle legacy success response (HTTP 200 but no JSON success flag)
      console.log("✅ FRONTEND: Booking email sent (legacy response) for request:", request);
      return true;
    } else {
      console.error("❌ FRONTEND: Failed to send booking email:", {
        request,
        response: response.data
      });
      return false;
    }
  } catch (error) {
    console.error("❌ FRONTEND: Error sending booking email:", error);
    return false;
  }
};
  // Use the submitted data to set the state
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    })
  }
handleStockNumberChange(stockNumber) {
  // No-op - fields won't show for installers anyway
}

handleDealNumberChange(dealNumber) {
  // No-op - fields won't show for installers anyway  
}
  handleCancel = e => {
    e.preventDefault();
    ReactGA.event({category: 'Installer', action: 'Cancel Estimate', label: 'prod'});
    this.props.history.push("/requestimates");
    return;
  }

  handleNotes(notes) {
    this.setState({notes})
  }

// UPDATED: Use shared pricing calculations
handleServices(services, total, discount) {
  console.log("handleServices called with:", { services, total, discount });
  
  // Validate the totals using shared pricing module
  const calculatedTotal = SharedRequestPricing.calculateRequestTotal(services);
  const calculatedDiscount = SharedRequestPricing.calculateRequestDiscount(services);
  
  // Log comparison for debugging
  if (Math.abs(total - calculatedTotal) > 0.01 || Math.abs(discount - calculatedDiscount) > 0.01) {
    console.warn("Total mismatch detected:", {
      passedTotal: total,
      calculatedTotal: calculatedTotal,
      passedDiscount: discount,
      calculatedDiscount: calculatedDiscount
    });
  }
  
  // Use calculated values for consistency
  this.setState({
    services, 
    total: calculatedTotal,      // Use shared calculation
    discount: calculatedDiscount // Use shared calculation
  });
}

  handleCustomer(customer, customerName, customerType) {
    //    //console.log("Handle Customer selection", customer);
        this.setState({customer, customerName, customerType});
      }
    
// In WalkInForm - Enhanced handleVIN method
handleVIN(vehicle) {
    console.log("Update vehicle state", vehicle);
    this.setState({ vehicle }, () => {
        // Auto-advance if this is a referral or duplicate AND vehicle is FULLY complete
        if ((this.state.referralId || this.state.duplicateRequestId) && this.checkVehicleComplete()) {
            // Add a small delay to ensure all UI updates are complete
            setTimeout(() => {
                if (this.checkVehicleComplete()) { // Double-check after delay
                    console.log("Vehicle fully populated - auto-advancing to step 3");
                    this.setState({ currentStep: 3 });
                }
            }, 500);
        }
    });
}
// Separate method to check vehicle completion
checkVehicleComplete = () => {
    return this.state.vehicle && 
           this.state.vehicle.year && 
           this.state.vehicle.make && 
           this.state.vehicle.model && 
           this.state.vehicle.trim && 
           this.state.vehicle.body;
};

handleDueDate(date) {
    this.setState({ dueDate: date })
  }

  handleAvailableDate(date) {
    this.setState({availableDate: date})
  }

  readAuth = async (installerId) => {
    let installerRequest = `/installerAuth/${installerId}`;
    const  { data : installer }  =  await API.get(installerRequest);
  //  //console.log("Installer :", installer);
    this.setState( {authenticated : installer[0].authenticated, auth : installer[0]});
  }

  addRequestState = async (requestId, requeststate, requestService) => {
    const state = {
      requestId: requestId,
      stateDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      requestStatus: requeststate,
      serviceId: requestService,
      changedByUserId: this.props.user.User_id,
      changedByUserType: this.props.userType
    };

    const apiEndpoint = `/requestState`;
    await API.post(apiEndpoint, state);
    return null;
  };

  // create a jumbo object of requestimate and vehicle and send it to a service
  addVehicle = async () => {
    const { vehicle } = this.state;
    await API.post(`/vehicles`, vehicle);
     return null;
  };

  addCalendar = async () => {
    let calendar = {
      requestId: this.state.newRequestId,
      installerId : this.props.typeId,
      installerCapacity : this.props.capacity,
      startDate : convertToUTC(this.state.availableDate).format("MM-DD-YYYY"),
      location_id: this.state.formLocationId || 0
    }
    // take the work requested and create the draft calendar entries
    const { data : newCalendar } = await API.post(`/schedule/`, calendar)
    
    return newCalendar;
    }

    bookCalendarEntries = async () => {
      const calendarEntry = {
        requestId: this.state.newRequestId,
        installerId: this.props.typeId,
        serviceId: null,
        workStatus: "booked",
        workDate: convertToUTC(this.state.availableDate).format("YYYY-MM-DD HH:mm:ss"),
        location_id: this.state.formLocationId || 0
      };
      await API.put(`/installerCalendarProgress/${this.state.newRequestId}`, calendarEntry);
    }

    addAppointment = async (appointment) => {
         let readAppt = `/readAppt/${appointment}`;        
         const { data: appt } = await API.get(readAppt);
     
     //    //console.log("Here's the data for the appointment :", appt);
     //    //console.log("description :", description);
        let calEntry = appt[0];
      //console.log("AddAppt : auth object : ", this.state.auth);
        let summary = `${calEntry.Year} ${calEntry.Make} ${calEntry.Model}`;
         let newAppt = {
             request : appointment,
             summary : summary,
             calendar : this.state.auth.calendar_id,
             description : "",
             startDate : calEntry.work_date,
             duration : calEntry.request_duration,
             installerId: this.props.typeId,
         };
         //console.log ("AddAppointment : Add to the calendar ", newAppt);
     
         let apptAdd = `/addAppt/`;
         await API.put(apptAdd, newAppt);
         return;
     };
    
addNote = async (newRequestId) => {
  if (!this.state.notes) {
    console.log("No notes to add, skipping...");
    return null;
  }

  let newNote = {
    requestId: newRequestId || this.state.newRequestId,
    noteDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    noteText: this.state.notes,
    userType: this.props.userType,
    userId: this.props.typeId
  }

  console.log("Adding note:", newNote);
  const { data: newRequestNote } = await API.post("/requestnotes/", newNote);
  return newRequestNote;
};

// UPDATED: Use shared pricing calculations for request creation
addRequest = async (pricingBreakdown, createAppointment = false) => {

  console.log("Tax debugging when adding the request:", {
  taxPercent: this.state.taxPercent,
  customerType: this.state.customerType,
  finalAmount: pricingBreakdown.finalAmount,
  calculatedTax: pricingBreakdown.taxes
});

  let newRequest = {
    requestType: this.props.userType,
    requestor: this.state.customer,
    serviceRequested: this.state.services[0].service_category + " - " + this.state.services[0].description,
    // UPDATED: Use calculated values from pricing breakdown
    requestTotal: pricingBreakdown.originalTotal,      // Original total (before discounts)
    requestDiscount: pricingBreakdown.totalDiscount,   // Total discount amount
    requestFee: pricingBreakdown.platformFee,          // NEW: Post-discount fee
    requestDuration: pricingBreakdown.totalDuration,   // Total duration
    requestTaxes: pricingBreakdown.taxes,              // Tax amount (varies by job type)
    assignedTo: this.props.typeId,
    createdBy: this.props.typeId,
    availableDate: dateService.toAPIDate(this.state.availableDate),
    dueDate: dateService.toAPIDate(this.state.availableDate),
    currentState: "new",
    createdDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    vin: this.state.vehicle.vin,
    createdType : "installer",
    installerCatalog : this.props.typeId,
    location_id: this.state.referralLocationId || this.state.formLocationId
  }

  // If this is a wholesale request entered by the installer
  if (this.state.customerType === "whole") {
    newRequest.requestType = "dealer";
    newRequest.currentState = "scheduled";
  }

  // If this is a retail walk-in being booked as an appointment, set as scheduled
  if (this.state.customerType !== "whole" && createAppointment) {
    newRequest.currentState = "scheduled";
  }

  // process the services requested array to create the right value
  if (this.state.services.length > 1) {
    newRequest.serviceRequested = newRequest.serviceRequested + " + " + (this.state.services.length-1);
  }

  const response = await API.post("/requestimates/", newRequest);
  console.log("addRequest API response:", response);
  console.log("addRequest API response.data:", response.data);

  // Extract the request ID from the response - handle various formats
  const newRequestId = response.data?.request_id || response.data?.requestId || response.data?.id || response.data;
  console.log("addRequest extracted newRequestId:", newRequestId);

  this.setState({ newRequestId });
  return newRequestId;
}

// UPDATED: Use shared pricing calculations for services
addServices = async (requestId, pricingBreakdown) => {
  console.log("Services being saved:", this.state.services);
  console.log("Pricing breakdown:", pricingBreakdown);
  
  // Determine job type for submission
  const jobType = this.state.customerType === "whole" ? "dealer" : "retail";
  const taxRate = this.state.customerType === "whole" ? 0 : this.state.taxPercent;
  
  // Prepare services using shared pricing module
  const submissionData = SharedPricingUtils.prepareForSubmission(this.state.services, {
    jobType: jobType,
    taxRate: taxRate
  });
  
  const newRequestService = {
    requestId: await requestId,
    serviceId: "",
    serviceAmount: 0,
    serviceValue: 0,         // NEW: Final amount after discount
    serviceDiscount: 0,
    serviceDuration: 0,
    serviceFee: 0,           // NEW: Service-level fee
    serviceState: "new",
    serviceDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    customDescription: "",
    retailPrice: 0,
    recommendedProductId: null,  // Product recommendation for technician
    serviceQuantity: 1,
    unitPrice: 0
  }

  for (let i = 0; i < submissionData.services.length; i++) {
    const service = submissionData.services[i];

    // UPDATED: Use calculated values from shared pricing module
    newRequestService.serviceId = service.service_id;
    newRequestService.serviceAmount = service.service_amount;     // Original amount
    newRequestService.serviceValue = service.service_value;       // Final amount after discount
    newRequestService.serviceDiscount = service.service_discount; // Discount amount
    newRequestService.serviceDuration = service.service_duration; // Duration
    newRequestService.serviceFee = service.service_fee;           // Service-level fee (post-discount)
    newRequestService.customDescription = service.custom_description || service.description;
    newRequestService.retailPrice = service.retail_price || null;
    newRequestService.recommendedProductId = service.recommended_product_id || null;
    newRequestService.serviceQuantity = service.quantity || 1;
    newRequestService.unitPrice = service.unit_price || service.service_amount;

    console.log(`Service ${i + 1}:`, {
      serviceId: service.service_id,
      description: service.description,
      serviceAmount: service.service_amount,
      serviceValue: service.service_value,
      serviceDiscount: service.service_discount,
      serviceFee: service.service_fee,
      retailPrice: service.retail_price,
      quantity: service.quantity,
      unitPrice: service.unit_price
    });

    await API.post("/requestService", newRequestService);
  }
  return null;
}
 
addOffer = async (createAppointment = false, totalDuration = 1) => {
  // Determine the correct status - "scheduled" if booking appointment or dealer job, otherwise "offered"
  const offerStatus = (this.state.customerType === "whole" || createAppointment) ? "scheduled" : "offered";

  const jobDuration = parseInt(totalDuration) || 1;
  const calculatedEndDate = moment(this.state.availableDate).add(jobDuration - 1, 'days');

  const newRequestOffer = {
    requestId: this.state.newRequestId,
    installerId: this.props.typeId,
    currentStatus : offerStatus,
    dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    startDate: dateService.toScheduledDateTime(
      this.state.availableDate,
      dateService.getTimeForDate(this.state.operatingHours, this.state.availableDate, 'open')
    ),
    endDate: dateService.toScheduledDateTime(
      calculatedEndDate,
      dateService.getTimeForDate(this.state.operatingHours, calculatedEndDate, 'close')
    ),
    location_id: this.state.formLocationId || 0
  }
console.log("Sending requestOffer with status:", offerStatus, newRequestOffer);

  await API.post("/requestoffered", newRequestOffer);
  return null;
};


  _next() {
    let currentStep = this.state.currentStep
    // If the current step is 1 or 2, then add one on "next" button click
    currentStep = currentStep >= 4 ? 5 : currentStep + 1
    this.setState({ currentStep: currentStep })
  }

  _prev() {
    let currentStep = this.state.currentStep
    // If the current step is 2 or 3, then subtract one on "previous" button click
    currentStep = currentStep <= 1 ? 1 : currentStep - 1
    this.setState({ currentStep: currentStep })
  }

  // The "next" and "previous" button functions
  get previousButton() {

    let currentStep = this.state.currentStep;

    // If the current step is not 1, then render the "previous" button
    if (currentStep !== 1) {
      return (<button className="jv-btn jv-btn-tertiary" type="button" onClick={this._prev}>Previous</button>)
    }

    // ...else return nothing
    return null;

  }

  get nextButton() {
    let currentStep = this.state.currentStep;
    // If the current step is not 4, then render the "next" button
    if(currentStep < 5){
        let disable = true;
        if (currentStep === 1 && this.state.customer) {
          disable = false;
        }
        if (currentStep === 2 && this.checkVehicleComplete()) {
          disable = false;
        }
        if (currentStep === 3 && this.state.services.length > 0) {
          disable = false;
        }
        if (currentStep === 4) {
          disable = false;
        }
      return (
        <button
          className="jv-btn jv-btn-primary float-right"
          type="button" disabled={disable} onClick={this._next}>
        Next
        </button>        
      )
    } else {
      // ... must be the submit time...
      // Show same options for both dealer and retail customers:
      // Email estimate checkbox, Create Estimate button, Book Appointment button
      const needsLocation = isMultiLocation(this.props.locations) && !this.state.formLocationId;
      const submitDisabled = this.state.loading || needsLocation;
      return (
        <React.Fragment>
          <div className="d-flex align-items-center">
            <div className="form-check mr-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="sendEstimate"
                checked={this.state.sendEstimate}
                onChange={(e) => this.setState({ sendEstimate: e.target.checked })}
              />
              <label className="form-check-label" htmlFor="sendEstimate">
                Email Estimate
              </label>
            </div>
            <button
              className="btn btn-outline-primary mr-2"
              type="button"
              onClick={(e) => this.handleSubmit(e, false)}
              disabled={submitDisabled}>
              {this.state.loading && <span>
                <i className="fa-sharp fa-solid fa-arrows-rotate fa-spin" />
              </span>}
              {!this.state.loading && <span>Create Estimate</span>}
            </button>
            <button
              className="jv-btn jv-btn-primary"
              type="button"
              onClick={(e) => this.handleSubmit(e, true)}
              disabled={submitDisabled}>
              {this.state.loading && <span>
                <i className="fa-sharp fa-solid fa-arrows-rotate fa-spin" />
              </span>}
              {!this.state.loading && <span><i className="fa-sharp fa-regular fa-calendar"></i> Book Appointment</span>}
            </button>
          </div>
        </React.Fragment>
      );
    }

  };

  get steepOne () {
    if (!this.state.customer) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white">
            </button>
            <br />
            Customer
            <div className="line-50-right"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-solid fa-check"></i>
          </button>
          <br />
          Customer
          <div className="line-50-right"></div>
        </div>
      </li>
    );
  };
  get steepTwo () {
    if (!this.state.vehicle) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white">
            </button>
            <br />
            Vehicle
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-solid fa-check"></i>
          </button>
          <br />
          Vehicle
          <div className="line-100"></div>
        </div>
      </li>
    );
  };
  get steepThree () {
    if (this.state.services < 1) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Work
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-solid fa-check"></i>
          </button>
          <br />
          Work
          <div className="line-100"></div>
        </div>
      </li>
    );
  };
  get steepFour () {
    if (!this.state.notes) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Notes
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-solid fa-check"></i>
          </button>
          <br />
          Notes
          <div className="line-100"></div>
        </div>
      </li>
    );
  };
  get steepFive () {
    if (this.state.currentStep !== 5 && this.state.dueDate) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Dates
            <div className="line-50-left"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-solid fa-check"></i>
          </button>
          <br />
          Dates
          <div className="line-50-left"></div>
        </div>
      </li>
    );
  };


  // This is also where when all the validation is completed, we push the new record
  // and redirect the page to the requestimate form with the parameters set
  render() {

    return (
      <React.Fragment>
        <div className="bg-white border border-secondary">
          <div className="col-lg-12 text-right">
            <button className="btn" type="button" onClick={this.handleCancel}>
              <i className="fa-sharp fa-solid fa-xmark"></i>
            </button>
          </div>

          <div className="col-lg-12 d-flex justify-content-center">
            <ul className="col-lg-5 nav nav-pills nav-fill text-center">
              {this.steepOne}
              {this.steepTwo}
              {this.steepThree}
              {this.steepFour}
              {this.steepFive}
            </ul>
          </div>
          <br />
          <br />
          <br />
          <div className="col-lg-12 p-0">
            <CustomerForm
                currentStep={this.state.currentStep} 
                userType = "installer"
                vehicle={this.state.vehicle}
                availableDate = {this.state.availableDate}
                dueDate = {this.state.dueDate}
                services={this.state.services}
                notes = {this.state.notes}
                dealerships = {this.state.dealerships}
                handleCustomer={this.handleCustomer}
                installer={this.state.installer}
                mode={"search"}
                customer={this.state.customer}
                customerName={this.state.customerName}
                customerEmail={this.state.customerEmail}
                customerType={this.state.customerType}
                />       
            <VehicleSelectForm
              currentStep={this.state.currentStep}
              handleVIN={this.handleVIN}
                onStockNumberChange={this.handleStockNumberChange}  // ADD THIS LINE
              notes = {this.state.notes}
              default = {""}
              customer = {this.state.customer}
              installer = {this.state.installer}
              customerType= {this.state.customerType}
              userType={"installer"}
              vehicle={this.state.vehicle} />
            <ServiceForm
                userType={this.props.userType}
                typeId={this.props.typeId}
                currentStep={this.state.currentStep}
                handleServices={this.handleServices}
                total={this.state.total}
                customerType= {this.state.customerType}
                vehicle={this.state.vehicle}
                discount={this.state.discount}
                category={"Paint"}
                services={this.state.services}
                notes = {this.state.notes}
                serviceHint={this.state.serviceHint}
                duplicateRequestId={this.state.duplicateRequestId}/>
            <NotesForm 
                currentStep={this.state.currentStep} 
                vehicle={this.state.vehicle}
                userType = "installer"
                requestType = {this.state.customerType}
                availableDate = {this.state.availableDate}
                dueDate = {this.state.dueDate}
                services={this.state.services}
                notes = {this.state.notes}
                handleNotes={this.handleNotes}
                  onDealNumberChange={this.handleDealNumberChange}  // ADD THIS LINE
                />       
            <DatesForm
                userType={this.props.userType}
                typeId={this.props.typeId}
                selectedLocationId={this.props.selectedLocationId}
                currentStep={this.state.currentStep}
                handleAvailableDate={this.handleAvailableDate}
                availableDate={this.state.availableDate}
                vehicle={this.state.vehicle}
                services={this.state.services}
                notes={this.state.notes}
                discount={this.state.discount}
                customer={this.state.customerName}
                excludeDays={this.state.excludeDays}
            />

            {this.state.currentStep === 5 && isMultiLocation(this.props.locations) && !this.props.selectedLocationId && (
              <div className="text-center my-3 d-flex align-items-center justify-content-center">
                <label className="mb-0 mr-2 font-weight-bold">Location:</label>
                <LocationSelector
                  locations={this.props.locations}
                  selectedLocationId={this.state.formLocationId}
                  onChange={(locationId) => this.setState({ formLocationId: locationId })}
                  includeAll={false}
                />
              </div>
            )}

            <div className="m-5 d-flex justify-content-center">
              {/* <pre>{this.state.vehicle}</pre> */}
              <div className="p-2">
                {this.previousButton}
              </div>
              <div className="p-2">
                {this.nextButton}
              </div>
            </div>

          </div>
        </div>
      </React.Fragment>
    );
  };

}
export default withRouter(WalkinForm);